'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { sendGeoblockImpressionEvent } from '@/modules/googleAnalytics/events/gamesEvents';
import { useGetCommonStore } from '@/store';

export const GameErrorGeoBlocked = () => {
  const { t } = useTranslation('common');

  const pathname = usePathname();

  const useCommonStore = useGetCommonStore();
  const countryCode = useCommonStore.use.countryCode();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUser = useCommonStore.use.pendingUser();

  const sent = useRef(false);

  useEffect(() => {
    // Wait for auth state to settle so `user` is reported correctly.
    if (sent.current || pendingUser) return;
    sent.current = true;

    sendGeoblockImpressionEvent({
      page_path: pathname,
      user: isAuthenticated ? 'authorized' : 'unauthorized',
      effective_country: (countryCode ?? '').toLowerCase(),
    });
  }, [pendingUser, isAuthenticated, pathname, countryCode]);

  return (
    <>
      <ImageComponent
        alt="geo blocked icon"
        height={80}
        src="/game/geo-blocked.webp"
        width={80}
      />
      <h2 className="error-title">{t('game.geoBlocked.title')}</h2>
      <p className="error-subtitle">{t('game.geoBlocked.subtitle')}</p>
    </>
  );
};
